<div class="comment-msg-p" style="opacity: 79%">

  <i class="table-material-icons">warning</i>
  There are premium cells with values hidden in current view , you must unhide them before proceeding
</div>
